import React from "react";
import { Box, Card, CardMedia } from "@mui/material";
import fondo from '../img_icons/fondo.svg';

const ImagenLogin = () => {
    return(
        <Box sx={{ 
            display: { xs: 'none', sm: 'none', md: 'block' }, // Solo visible en escritorio
            width: '100vw', 
            height: '100vh', 
            backgroundSize: 'cover',  
        }}>
            <Card sx={{ borderRadius: '0.2%', width: '100%', height: '100%', padding: '0%', justifyContent: 'center', alignItems: 'center', }}>
                <CardMedia 
                    component="img"
                    sx={{ 
                        width: '100%', 
                        height: '100%',
                        display: { xs: 'flex', sm: 'flex' },   
                        borderRadius: '0.2%',   
                    }}
                    image={fondo}
                    alt={'imagen prueba'}
                    style={{ 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        alignContent: 'center',
                        textAlign: 'center'
                }}>
                </CardMedia>
            </Card>
        </Box>
    );
}

export default ImagenLogin;